export class App1ConfigSettings {

    loggingLevel: string;
    envName: string;
    production: boolean;
    shouldEnforceLogin: boolean;
    checkRecaptchaEnabled: boolean;

    constructor(
        loggingLevel: string,
        envName: string,
        production: boolean,
        shouldEnforceLogin: boolean,
        checkRecaptchaEnabled: boolean
    ) {
        this.loggingLevel = loggingLevel
        this.envName = envName
        this.production = production
        this.shouldEnforceLogin = shouldEnforceLogin
        this.checkRecaptchaEnabled = checkRecaptchaEnabled
    }

}
